import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggler"];

  connect() {
    this.togglerTarget.checked = this.storedDarkMode;
  }

  toggle() {
    window.localStorage.setItem("dark-mode", this.isDarkModeEnabled);
  }

  get isBrowserDarkModeEnabled() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  get isDarkModeEnabled() {
    return this.togglerTarget.checked;
  }

  get storedDarkMode() {
    return [null, "true"].includes(window.localStorage.getItem("dark-mode"));
  }
}
